import AddressProofFileExtensionIsInvalid from './AddressProofFileExtensionIsInvalid';
import AddressProofFileIsMissing from './AddressProofFileIsMissing';
import AddressProofFileIsEmpty from './AddressProofFileIsEmpty';
import AddressProofFileSizeIsExceeded from './AddressProofFileSizeIsExceeded';
import IncorrectProofType from './IncorrectProofType';
import AddressProofError from './AddressProof/AddressProofError';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const uploadAddressProofErrorHandler = (error) => {
    switch (error.code) {
        case 'INCORRECT_FILE_EXTENSION':
            throw new AddressProofFileExtensionIsInvalid({ cause: error });
        case 'MISSING_FILE':
            throw new AddressProofFileIsMissing({ cause: error });
        case 'EMPTY_FILE':
            throw new AddressProofFileIsEmpty({ cause: error });
        case 'MAXIMUM_FILE_SIZE_EXCEEDED':
            throw new AddressProofFileSizeIsExceeded({ cause: error });
        case 'INCORRECT_PROOF_TYPE':
            throw new IncorrectProofType({ cause: error });
        default:
            throw new AddressProofError({ cause: error });
    }
};
export default uploadAddressProofErrorHandler;
